import React from 'react';
import {setStepCalc} from "../calc/calcSlice";
import {setBirthDate, setIssueDate} from "../calc/personSlice";
import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
const CaseButton = (props) => {
    return (
        <div>
            { props.active ?
                <div type="submit" className="button button-1 button-novostroiki-1 button-step-23"
                     id="button-step-23" value="Далее"
                >
                    Далее
                </div> :
                <div>
                    <div type="submit" className="button button-1 button-novostroiki-2 button-step-23"
                         id="button-step-23" value="Далее"
                    >
                        Далее
                    </div>
                    <div className="validacia">
                        <p id="validacia-text"
                           className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                            Заполните все поля</p>
                    </div>
                </div>
            }

        </div>
    );
};

export default CaseButton;